// extracted by mini-css-extract-plugin
module.exports = {"Container":"PlansList_Container__3Ff7k","ItemContainer":"PlansList_ItemContainer__3tpWO","Item":"PlansList_Item__2uGrL"};